import {Component, forwardRef, Inject, Input, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {Location} from '@angular/common';
import {Router} from '@angular/router';
import {MenuItem} from 'primeng/api';

import {UserService} from '@app/core';
import {RouteLink, UserType} from '@app/shared';
import {AppComponent} from '../../app.component';

@Component({
  selector: 'app-menu',
  templateUrl: './app-menu.component.html',
  styleUrls: ['./app-menu.component.css']

})
export class AppMenuComponent implements OnInit {

  @Input() reset: boolean;

  RouteLink: typeof RouteLink = RouteLink;
  UserType: typeof UserType = UserType;

  onelynkModel: any[];
  paradiseModel: any[];

  constructor (@Inject(forwardRef(() => AppComponent)) public app: AppComponent, public user: UserService) { }

  ngOnInit() {
    this.onelynkModel = [
      {
        label: 'Employee Self Service', icon: 'fa fa-fw fa-user',
        items: [
          {label: 'My Profile', routerLink: [RouteLink.Profile]},
          {label: 'Self-Appraisal', routerLink: [RouteLink.SelfAppraisal]},
          {label: 'Leave Request', routerLink: [RouteLink.LeaveRequest]},
          {label: 'Qualifying Life Event', routerLink: [RouteLink.QualifyingLifeEvent]},
          {label: 'Benefit Selection', routerLink: [RouteLink.BenefitSelection]},
          {label: 'Vacation Request', routerLink: [RouteLink.VacationRequest]},
          {label: 'Work Authorization', routerLink: [RouteLink.WorkAuthSummary]},
          {label: 'Training Request', routerLink: [RouteLink.TrainingRequest]},
        ]
      },
      {
        label: 'Manager Self Service', icon: 'fa fa-fw fa-globe',
        items: [
          {label: 'Employee Changes', routerLink: [RouteLink.EmployeeChangeRequest]},
          {label: 'Recruit-to-Hire', routerLink: [RouteLink.RecruitToHire]},
          {label: 'Employee Appraisal', routerLink: [RouteLink.EmployeeAppraisal]},
        ]
      },
      {
        label: 'Human Capital Management', icon: 'fa fa-fw fa-sitemap',
        items: [
          {label: 'Resource Management', routerLink: [RouteLink.ResourceManagement]},
          {label: 'Appraisal Setup', routerLink: [RouteLink.AppraisalAdmin]},
          {label: 'Benefits', routerLink: [RouteLink.BenefitProvider]},
          {label: 'Employee Class', routerLink: [RouteLink.EmployeeClass]},
          {label: 'Job Posting Site', routerLink: [RouteLink.JobPostingSite]},
          {label: 'Offer Letters', routerLink: [RouteLink.OfferLetter]},
          {label: 'Offer Letter Clauses', routerLink: [RouteLink.OfferLetterClause]},
          {label: 'Positions', routerLink: [RouteLink.Position]},
          {label: 'Position Grade', routerLink: [RouteLink.PositionGrade]},
          {label: 'PTO Policies', routerLink: [RouteLink.PtoPolicy]},
          {label: 'Screening Questions', routerLink: [RouteLink.ScreeningQuestion]},
          {label: 'Screening Categories', routerLink: [RouteLink.ScreeningQuestionCategory]},
          {label: 'Recruit-to-Hire', routerLink: [RouteLink.RecruitToHire]},
          {label: 'Virtual Orientation', routerLink: [RouteLink.VirtualOrientation]},
          {label: 'Termination Checklist', routerLink: [RouteLink.EmployeeOffboardingChecklist]},
        ]
      },
      {
        label: 'Time & Expense', icon: 'fa fa-fw fa-clock-o',
        items: [
          {label: 'My Timesheet', routerLink: [RouteLink.Timesheet]},
          {label: 'Employee Timesheets', routerLink: [RouteLink.TimesheetManager]},
          {label: 'Timesheet Admin', routerLink: [RouteLink.TimesheetAdmin]},
          {label: 'Expense Reports', routerLink: [RouteLink.ExpenseReport]},
        ]
      },
      {
        label: 'Procurement', icon: 'fa fa-fw fa-shopping-cart',
        items: [
          {label: 'Purchase Requisition/PO', routerLink: [RouteLink.PurchaseRequisition]},
          {label: 'Item Receipt', routerLink: [RouteLink.Receipt]},
          {label: 'Item Catalog', routerLink: [RouteLink.ItemCatalogAdmin]},
          {label: 'Item Return', routerLink: [RouteLink.PurchaseReturn]},
          {label: 'Vendors', routerLink: [RouteLink.Vendor]},
          {label: 'Material Order', routerLink: ['/procurement/material-order']},
          {label: 'Vendor Bills', routerLink: [RouteLink.VendorInvoice]},
        ]
      },
      {
        label: 'Orders', icon: 'fa fa-fw fa-list-alt',
        items: [
          {label: 'Sales Order', routerLink: [RouteLink.SalesOrder]},
          {label: 'Packing Slip', routerLink: [RouteLink.PackingSlip]},
          {label: 'Sales Return', routerLink: [RouteLink.SalesReturn]},
          {label: 'Customers', routerLink: [RouteLink.Customer]},
          {label: 'Catalog Invoice', routerLink: [RouteLink.CatalogCustomerInvoice]},
          {label: 'Manual Contract/Project Invoice', routerLink: [RouteLink.ManualContractProjectCustomerInvoice]},
          {label: 'Contract/Project Invoice', routerLink: [RouteLink.ContractProjectCustomerInvoice]},
        ]
      },
      {
        label: 'Finance', icon: 'fa fa-fw fa-credit-card',
        items: [
          {label: 'Accounts Payable', routerLink: [RouteLink.AccountPayable]},
          {label: 'Account Groups', routerLink: [RouteLink.AccountGroup]},
          {label: 'Voucher Register', routerLink: [RouteLink.VoucherRegister]},
          {label: 'Chart of Accounts', routerLink: [RouteLink.SolMgrChartOfAccountsSetup]},
          {label: 'Accounts Receivable', routerLink: [RouteLink.AccountReceivable]},
          {label: 'General Ledger', routerLink: [RouteLink.GeneralLedger]},
          {label: 'Charge Codes', routerLink: [RouteLink.ChargeCodeAdmin]},
          {label: 'Finance Calendar', routerLink: [RouteLink.FinanceCalendar]},
          {label: 'Financial Report', routerLink: [RouteLink.FinancialReport]},
          {label: 'Payment Terms Setup', routerLink: [RouteLink.PaymentTermAdmin]},
        ]
      },
      {
        label: 'Payroll', icon: 'fa fa-fw fa-usd', routerLink: [RouteLink.Payroll]
      },
      {
        label: 'Contracts & Projects', icon: 'fa fa-fw fa-tasks',
        items: [
          {label: 'Bids', routerLink: [RouteLink.ContractBidLink, RouteLink.BidTab]},
          {label: 'Contracts', routerLink: [RouteLink.ContractBidLink, RouteLink.ContractTab]},
          {label: 'Estimates', routerLink: [RouteLink.ProjectEstimateLink, RouteLink.EstimateTab]},
          {label: 'Projects', routerLink: [RouteLink.ProjectEstimateLink, RouteLink.ProjectTab]},
          {label: 'Project Catalog', routerLink: [RouteLink.ProjectCatalog]},
          {label: 'Default Billing Plan', routerLink: [RouteLink.BillingPlanSummary]},
          {label: 'Project Status Reports', routerLink: [RouteLink.ProjectStatusReport]},

        ]
      },
      {
        label: 'Security Assessments', icon: 'fa fa-fw fa-lock',
        items: [
          {label: 'System', routerLink: [RouteLink.CyberplanSystemsSummary]},
          {label: 'Policy', routerLink: [RouteLink.CyberplanSecurityPolicy]},
          {label: 'Threats', routerLink: [RouteLink.CyberplanSecurityThreat]},
        ]
      },
      {
        label: 'Business Analytics', icon: 'fa fa-fw fa-file', routerLink: [RouteLink.Reporting]
      },
      {
        label: 'Support Files', icon: 'fa fa-files-o',
        items: [
          {label: 'Customer Onboarding', routerLink: [RouteLink.FileSharingOnboardingFiles]},
          {label: 'Supporting Documentation', routerLink: [RouteLink.FileSharingMaintenanceFiles]},
        ]
      },
      {
        label: 'Settings & Solutions', icon: 'fa fa-fw fa-cogs',
        items: [
          {label: 'Solution Manager', routerLink: [RouteLink.SolMgrMain]},
          {label: 'Run Setup Validations', routerLink: [RouteLink.SolMgrOrgSetupValidation]},
          {label: 'Run Transaction Validations', routerLink: [RouteLink.SolMgrTransactionValidation]},
        ]
      }
    ];

    this.paradiseModel = [
    ];

  }

  changeTheme(theme) {
    let themeLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('theme-css');
    themeLink.href = 'assets/theme/theme-' + theme + '.css';
  }

  changeLayout(layout) {
    this.app.layout = layout;
    let layoutLink: HTMLLinkElement = <HTMLLinkElement>document.getElementById('layout-css');
    layoutLink.href = 'assets/layout/css/layout-' + layout + '.css';
  }
}

@Component({
  selector: '[app-submenu]',
  template: `
        <ng-template ngFor let-child let-i="index" [ngForOf]="(root ? item : item.items)">
            <li [ngClass]="{'active-menuitem': isActive(i)}" [class]="child.badgeStyleClass">
                <a [href]="child.url||'#'" (click)="itemClick($event,child,i)" *ngIf="!child.routerLink" [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target"
                    (mouseenter)="hover=true" (mouseleave)="hover=false">
                    <i [ngClass]="child.icon"></i>
                    <span>{{child.label}}</span>
                    <span class="menuitem-badge" *ngIf="child.badge">{{child.badge}}</span>
                    <i class="fa fa-fw fa-angle-down" *ngIf="child.items"></i>
                </a>

                <a (click)="itemClick($event,child,i)" *ngIf="child.routerLink"
                    [routerLink]="child.routerLink" routerLinkActive="active-menuitem-routerlink" [routerLinkActiveOptions]="{exact: true}" [attr.tabindex]="!visible ? '-1' : null" [attr.target]="child.target"
                    (mouseenter)="hover=true" (mouseleave)="hover=false">
                    <i [ngClass]="child.icon"></i>
                    <span>{{child.label}}</span>
                    <span class="menuitem-badge" *ngIf="child.badge">{{child.badge}}</span>
                    <i class="fa fa-fw fa-angle-down" *ngIf="child.items"></i>
                </a>
                <div class="layout-menu-tooltip">
                    <div class="layout-menu-tooltip-arrow"></div>
                    <div class="layout-menu-tooltip-text">{{child.label}}</div>
                </div>
                <ul app-submenu [item]="child" *ngIf="child.items" [visible]="isActive(i)" [reset]="reset"
                    [@children]="app.slimMenu&&root ? isActive(i) ? 'visible' : 'hidden' : isActive(i) ? 'visibleAnimated' : 'hiddenAnimated'"></ul>
            </li>
        </ng-template>
    `,
  animations: [
    trigger('children', [
      state('hiddenAnimated', style({
        height: '0px'
      })),
      state('visibleAnimated', style({
        height: '*'
      })),
      state('visible', style({
        height: '*'
      })),
      state('hidden', style({
        height: '0px'
      })),
      transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
      transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
    ])
  ]
})
export class AppSubMenu {

  @Input() item: MenuItem;

  @Input() root: boolean;

  @Input() visible: boolean;

  _reset: boolean;

  activeIndex: number;

  hover: boolean;

  constructor (@Inject(forwardRef(() => AppComponent)) public app: AppComponent, public router: Router, public location: Location) { }

  itemClick(event: Event, item: MenuItem, index: number) {
    //avoid processing disabled items
    if (item.disabled) {
      event.preventDefault();
      return true;
    }

    //activate current item and deactivate active sibling if any
    if (item.routerLink || item.items) {
      this.activeIndex = (this.activeIndex === index) ? null : index;
    }

    //execute command
    if (item.command) {
      item.command({ originalEvent: event, item: item });
    }

    //prevent hash change
    if (item.items || (!item.url && !item.routerLink)) {
      event.preventDefault();
    }

    //hide menu
    if (!item.items) {
      if (this.app.overlayMenu || this.app.isMobile()) {
        this.app.overlayMenuActive = false;
        this.app.mobileMenuActive = false;
      }

      if (!this.root && this.app.slimMenu) {
        this.app.resetSlim = false;
      }
    }
  }

  isActive(index: number): boolean {
    return this.activeIndex === index;
  }

  unsubscribe(item: any) {
    if (item.eventEmitter) {
      item.eventEmitter.unsubscribe();
    }

    if (item.items) {
      for (let childItem of item.items) {
        this.unsubscribe(childItem);
      }
    }
  }

  @Input() get reset(): boolean {
    return this._reset;
  }

  set reset(val: boolean) {
    this._reset = val;

    if (this._reset && this.app.slimMenu) {
      this.activeIndex = null;
    }
  }
}
